import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import UnderlinedLink from 'reservations/base/components/UnderlinedLink';
import { BLUE } from 'reservations/brand/helpers/v1/palette';

type WaitlistMessageProps = { dataTestId: string; message: string };

const WaitlistMessage = ({ dataTestId, message }: WaitlistMessageProps) => (
  <Grid
    container
    direction="column"
    gap="24px"
    alignItems="center"
    justifyContent="center"
    marginTop="70px"
  >
    <Grid item>
      <Typography
        sx={{
          fontSize: '16px',
          textAlign: 'center'
        }}
        data-testid={dataTestId}
      >
        {message}
      </Typography>
    </Grid>
    <Grid item>
      <UnderlinedLink href="/locations" openNewTab={false} color={BLUE}>
        Return to Homepage
      </UnderlinedLink>
    </Grid>
  </Grid>
);

export default WaitlistMessage;
